export default __webpack_public_path__ + "static/media/table.4c29e556.svg";